import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Servizio, Immobile } from '../models';
import { ServizioImmobileService } from './servizio-immobile.service'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { FormGroup, FormArray, FormControl } from '@angular/forms/src/model';
import { AlertService } from 'app/services/alert.service';

@Injectable()
export class CartService {
	flagsServizioCatasto: Array<boolean> = [false, false, false];
	totaleCarello: number = 0;
	serviziAcquistatiArray: Array<Servizio>;

	serviziAcquistatiVisura: Array<Servizio> = [undefined, undefined, undefined];
	serviziAcquistatiPlanimetria: Array<Servizio> = [undefined, undefined, undefined];
	serviziAcquistatiCopiaAttoNotarile: Array<Servizio> = [undefined, undefined, undefined];
	serviziAcquistatiCertificazioneEnergetica: Array<Servizio> = [undefined, undefined, undefined];

	constructor(private servizioImmobileService: ServizioImmobileService,
		private alertService: AlertService) { }

	fnAcquistaServizioAssicurazione(result: any, formGroup: FormGroup) {
		if (result) {
			// il servizio Assicurazione Affitto è stato rinominato -> Visura titolo telematico (copia conforme atto)
			this.servizioImmobileService.getByDD('Servizio Immobile', 'Visura titolo telematico (copia conforme atto)')
				.subscribe(response => { this.fnAggiungiServizio(response, formGroup) });
		}
	}

	fnAcquistaServizioCalcoloSuperficie(result: any, formGroup: FormGroup) {
		if (result) {
			this.servizioImmobileService.getByDD('Servizio Immobile', 'Calcolo della Superficie da Planimetria')
				.subscribe(response => { this.fnAggiungiServizio(response, formGroup) });
		}
	}

	fnAcquistaServizioVisuraCatastale(result: any, formGroup: FormGroup, index: number): Observable<boolean> {
		return this.servizioImmobileService.getByDD('Servizio Immobile - Documenti Obbligatori', 'Visura Catastale')
			.map(response => {
				if (result) {
					this.serviziAcquistatiVisura[index] = response;
					if (response.tipologiaServizio.descrizione === 'Visura Catastale') {
						let counter = 0;
						this.serviziAcquistatiVisura.forEach(function (value) {
							if (value != undefined && value.id === response.id) {
								counter += 1;
							}
						});
						if (counter < 3) {
							if (formGroup != undefined) {
								let items = formGroup.controls.items as FormArray;
								let item = items.controls[index] as FormGroup;

								let formControlsDC = item.controls['datoCatastale'] as FormControl;
								let formControlsFC = item.controls['foglioCatasto'] as FormControl;
								let formControlsPC = item.controls['particellaCatasto'] as FormControl;
								let formControlsSC = item.controls['subCatasto'] as FormControl;
								let formControlsCC1 = item.controls['categoriaCatastale'] as FormControl;
								let formControlsCC2 = item.controls['classeCatastale'] as FormControl;
								let formControlsCC3 = item.controls['consistenzaCatastale'] as FormControl;
								let formControlsVCC = item.controls['valoreConsistenza'] as FormControl;
								let formControlsZC = item.controls['zonaCensuariaCatasto'] as FormControl;
								let formControlsR = item.controls['rendita'] as FormControl;

								if (formControlsDC.hasError('required')) {
									formControlsDC.setErrors(null);
								}
								if (formControlsZC.hasError('required')) {
									formControlsZC.setErrors(null);
								}
								if (formControlsFC.hasError('required')) {
									formControlsFC.setErrors(null);
								}
								if (formControlsPC.hasError('required')) {
									formControlsPC.setErrors(null);
								}
								if (formControlsSC.hasError('required')) {
									formControlsSC.setErrors(null);
								}
								if (formControlsCC1.hasError('required')) {
									formControlsCC1.setErrors(null);
								}
								if (formControlsCC2.hasError('required')) {
									formControlsCC2.setErrors(null);
								}
								if (formControlsCC3.hasError('required')) {
									formControlsCC3.setErrors(null);
								}
								if (formControlsVCC.hasError('required')) {
									formControlsVCC.setErrors(null);
								}
								if (formControlsR.hasError('required')) {
									formControlsR.setErrors(null);
								}
							}
							this.totaleCarello += response.costoScontato;
							this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.');
							this.flagsServizioCatasto[index] = true;
							return true;
						}
						else {
							this.alertService.warn('Il servizio ' + response.tipologiaServizio.descrizione + ' esiste già nel carello.', true, 2000);
							return false;
						}
					}
				}
				return false;
			});
	}

	// Dialog documenti
	fnAcquistaServizioCertificazione(result: any, formGroup: FormGroup, index: number, immobile: Immobile): Observable<boolean> {
		return this.servizioImmobileService.getByDomDescWithCostoVar('Servizio Immobile - Documenti Obbligatori', 'Certificazione Prestazione Energetica', immobile)
			.map(response => {
				if (result) {
					this.serviziAcquistatiCertificazioneEnergetica[index] = response;
					if (response.tipologiaServizio.descrizione === 'Certificazione Prestazione Energetica') {
						let counter = 0;
						this.serviziAcquistatiCertificazioneEnergetica.forEach(function (value) {
							if (value != undefined && value.id === response.id) {
								counter += 1;
							}
						});
						if (counter < 3) {
							this.totaleCarello += response.costoScontato;
							this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.' + response.costoScontato);
							return true;
						} else {
							this.alertService.warn('Il servizio ' + response.tipologiaServizio.descrizione + ' esiste già nel carello.', true, 2000);
							return false;
						}
					}
				}
				return false;
			});
	}

	fnAcquistaServizioCopiaAttoNotarile(result: any, formGroup: FormGroup, index: number, immobile: Immobile): Observable<boolean> {
		return this.servizioImmobileService.getByDomDescWithCostoVar('Servizio Immobile - Documenti Obbligatori', 'Copia Atto Notarile', immobile)
			.map(response => {
				if (result) {
					this.serviziAcquistatiCopiaAttoNotarile[index] = response;
					if (response.tipologiaServizio.descrizione === 'Copia Atto Notarile') {
						let counter = 0;
						this.serviziAcquistatiCopiaAttoNotarile.forEach(function (value) {
							if (value != undefined && value.id === response.id) {
								counter += 1;
							}
						});
						if (counter < 3) {
							this.totaleCarello += response.costoScontato;
							this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.');
							return true;
						}
						else {
							this.alertService.warn('Il servizio ' + response.tipologiaServizio.descrizione + ' esiste già nel carello.', true, 2000);
							return false;
						}
					}
				}
				return false;
			});
	}

	fnAcquistaServizioPlanimetria(result: any, formGroup: FormGroup, index: number, immobile: Immobile): Observable<boolean> {
		return this.servizioImmobileService.getByDomDescWithCostoVar('Servizio Immobile - Documenti Obbligatori', 'Planimetria Catastale', immobile)
			.map(response => {
				if (result) {
					this.serviziAcquistatiPlanimetria[index] = response;
					if (response.tipologiaServizio.descrizione === 'Planimetria Catastale') {
						let counter = 0;
						this.serviziAcquistatiPlanimetria.forEach(function (value) {
							if (value != undefined && value.id === response.id) {
								counter += 1;
							}
						});
						if (counter < 3) {
							this.totaleCarello += response.costoScontato;
							this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.');
							return true;
						}
						else {
							this.alertService.warn('Il servizio ' + response.tipologiaServizio.descrizione + ' esiste già nel carello.', true, 2000);
							return false;
						}
					}
				}
				return false;
			});
	}

	fnAcquistaDocumenti(dominio: string, descrizione: string, immobile?: Immobile) {
		if (descrizione === 'Servizio Fotografico' || descrizione === 'Perizia Immobiliare' || descrizione === 'Certificazione Prestazione Energetica') {
			this.servizioImmobileService.getByDomDescWithCostoVar(dominio, descrizione, immobile)
				.subscribe(response => {
					this.fnAggiungiServizio(response, null)
				});
		} else {
			this.servizioImmobileService.getByDD(dominio, descrizione)
				.subscribe(response => {
					this.fnAggiungiServizio(response, null)
				});
		}
	}

	fnAcquistaServizioValutazione(result: any, formGroup: FormGroup) {
		if (result) {
			this.servizioImmobileService.getByDD('Servizio Immobile', 'Stima/Valutazione Economica')
				.subscribe(response => { this.fnAggiungiServizio(response, formGroup) });
		}
	}


	fnAcquistaServizioAttoProvenienza(result: any, formGroup: FormGroup) {
		if (result) {
			// il servizio Servizio Atto di Provenienza e stato rinominato -> Contratto Preliminare di Compravendita - Bozza
			this.servizioImmobileService.getByDD('Servizio Immobile', 'Contratto Preliminare di Compravendita - Bozza')
				.subscribe(response => { this.fnAggiungiServizio(response, formGroup) });
		}
	}

	fnAcquistaServizioFotografico(result: any, formGroup: FormGroup, immobile: Immobile) {
		if (result) {
			this.servizioImmobileService.getByDomDescWithCostoVar('Servizio Immobile', 'Servizio Fotografico', immobile)
				.subscribe(response => { this.fnAggiungiServizio(response, formGroup) });
		}
	}

	fnAggiungiServizio(response, formGroup: FormGroup) {
		if (this.serviziAcquistatiArray === undefined) {
			this.serviziAcquistatiArray = [response];
			this.totaleCarello += response.costoScontato;
			this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.', true, 2000);
		} else {
			if (this.serviziAcquistatiArray.find(this.ovFind.bind(response)) === undefined) {
				this.serviziAcquistatiArray.push(response);
				this.totaleCarello += response.costoScontato;
				this.alertService.success('Il servizio ' + response.tipologiaServizio.descrizione + ' è stato aggiunto nel carello.', true, 2000);
			} else {
				this.alertService.warn('Il servizio ' + response.tipologiaServizio.descrizione + ' esiste già nel carello.', true, 2000);
			}
		}

		// reset della validazione per i campi obbligatori
		if (formGroup != undefined) {
			if (response.tipologiaServizio.descrizione === 'Stima/Valutazione Economica') {
				formGroup.controls['prezzo'].reset();

			} else if (response.tipologiaServizio.descrizione === 'Certificazione Prestazione Energetica') {
				formGroup.controls['classeEnergetica'].reset();
				formGroup.controls['fcConsumo'].reset();
			} else if (response.tipologiaServizio.descrizione === 'Capacità di Spesa') {
				formGroup.controls['fcCapacitaSpesa'].reset();
			}
		}
	}

	eliminaServizio(index: number, formGroup: FormGroup) {
		if (formGroup != undefined) {
			if (this.serviziAcquistatiArray[index].tipologiaServizio.descrizione === 'Stima/Valutazione Economica') {
				formGroup.controls['prezzo'].reset();
			} else if (this.serviziAcquistatiArray[index].tipologiaServizio.descrizione === 'Certificazione Prestazione Energetica') {
				formGroup.controls['classeEnergetica'].reset();
				formGroup.controls['fcConsumo'].reset();
			} else if (this.serviziAcquistatiArray[index].tipologiaServizio.descrizione === 'Capacità di Spesa') {
				formGroup.controls['fcCapacitaSpesa'].reset();
			}
		}
		if (this.serviziAcquistatiArray[index].tipologiaServizio.descrizione != 'Pubblicazione Annuncio') {
			this.totaleCarello -= this.serviziAcquistatiArray[index].costoScontato;
			this.serviziAcquistatiArray.splice(index, 1);
		}
	}

	eliminaServizioVisura(index: number, formGroup: FormGroup) {
		this.totaleCarello -= this.serviziAcquistatiVisura[index].costoScontato;
		this.serviziAcquistatiVisura[index] = undefined;
		this.flagsServizioCatasto[index] = false;
		if (formGroup != undefined) {
			formGroup.controls['items'].reset();
		}
	}

	eliminaServizioCertificazione(index: number, formGroup: FormGroup) {
		this.totaleCarello -= this.serviziAcquistatiCertificazioneEnergetica[index].costoScontato;
		this.serviziAcquistatiCertificazioneEnergetica[index] = undefined;
		if (index == 0)
			if (formGroup != undefined) {
				formGroup.controls['classeEnergetica'].reset();
				formGroup.controls['fcConsumo'].reset();
				formGroup.controls['fcInAttesa'].reset();
				formGroup.controls['fcEsente'].reset();
			}
	}

	eliminaServizioCopiaAttoNotarile(index: number, formGroup: FormGroup) {
		this.totaleCarello -= this.serviziAcquistatiCopiaAttoNotarile[index].costoScontato;
		this.serviziAcquistatiCopiaAttoNotarile[index] = undefined;
	}

	eliminaServizioPlanimetria(index: number, formGroup: FormGroup) {
		this.totaleCarello -= this.serviziAcquistatiPlanimetria[index].costoScontato;
		this.serviziAcquistatiPlanimetria[index] = undefined;
	}

	svuotaCarello() {
		if (this.serviziAcquistatiArray != undefined) {
			this.serviziAcquistatiArray.splice(0, this.serviziAcquistatiArray.length);
		}
		this.serviziAcquistatiVisura = [undefined, undefined, undefined];
		this.serviziAcquistatiCertificazioneEnergetica = [undefined, undefined, undefined];
		this.serviziAcquistatiCopiaAttoNotarile = [undefined, undefined, undefined];
		this.serviziAcquistatiPlanimetria = [undefined, undefined, undefined];
		this.flagsServizioCatasto = [false, false, false];
		this.totaleCarello = 0;
	}

	carello(): boolean {
		let check = false;
		if (
			(this.serviziAcquistatiArray != undefined &&
				this.serviziAcquistatiArray.length > 0) ||
			this.serviziAcquistatiVisura[0] != undefined ||
			this.serviziAcquistatiVisura[1] != undefined ||
			this.serviziAcquistatiVisura[2] != undefined ||
			this.serviziAcquistatiCertificazioneEnergetica[0] != undefined ||
			this.serviziAcquistatiCertificazioneEnergetica[1] != undefined ||
			this.serviziAcquistatiCertificazioneEnergetica[2] != undefined ||
			this.serviziAcquistatiCopiaAttoNotarile[0] != undefined ||
			this.serviziAcquistatiCopiaAttoNotarile[1] != undefined ||
			this.serviziAcquistatiCopiaAttoNotarile[2] != undefined ||
			this.serviziAcquistatiPlanimetria[0] != undefined ||
			this.serviziAcquistatiPlanimetria[1] != undefined ||
			this.serviziAcquistatiPlanimetria[2] != undefined
		) {
			check = true;
		}
		return check;
	}

	ovFind(this: any, value: any, index: number, obj: Array<any>) {
		if (this.id === value.id) {
			return true;
		}
	}

	clearAlert() {
		this.alertService.clear();
	}

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/cart.service.ts